exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".settings .sticky-element{margin-bottom:5px}#close-acc{width:110px;margin:40px auto 60px;display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./components/dashboard/settings/settings.css
// module id = 784
// module chunks = 0